module.exports = __webpack_public_path__ + "static/media/page01.b60905f3.jpg";